import React from 'react';
import { Link } from 'react-router-dom';
import { List, Tag, Button, message, Card } from 'antd';
import fp from 'lodash/fp';
import { PlusOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_PROJECT_APPLICATION_SETTINGS,
  UPDATE_PROJECT_APPLICATION_SETTING,
  DELETE_PROJECT_APPLICATION_SETTING,
} from 'gql/projectApplicationSetting';
import { DeleteButton } from 'components/button';
import { useListActions } from 'hooks';
import { DateDisplay } from 'components/layout';

const sortData = fp.sortBy(['disabled', 'showPriority', 'startDate']);
const tagShowPriority = (showPriority) => {
  switch (showPriority) {
    case 0:
      return <Tag color="green">Opening</Tag>;
    case 1:
      return <Tag>Coming Soon</Tag>;
    case 2:
      return <Tag color="red">Closed</Tag>;
    default:
      return '';
  }
};
const ProjectApplicationSettings = () => {
  const { data, loading } = useQuery(GET_PROJECT_APPLICATION_SETTINGS, {
    variables: { state: 'ALL' },
  });
  const [updateSetting] = useMutation(UPDATE_PROJECT_APPLICATION_SETTING, {
    refetchQueries: [
      {
        query: GET_PROJECT_APPLICATION_SETTINGS,
        variables: { state: 'ALL' },
      },
    ],
  });
  const [deleteSetting] = useMutation(DELETE_PROJECT_APPLICATION_SETTING, {
    refetchQueries: [
      {
        query: GET_PROJECT_APPLICATION_SETTINGS,
        variables: { state: 'ALL' },
      },
    ],
    awaitRefetchQueries: true,
    onCompleted: () => {
      message.success('Funding Application Setting deleted successfully');
    },
    onError: () => {},
  });
  const listActions = useListActions({
    edit: {
      url: (item) => `/system-setting/project-application-settings/${item.id}`,
    },
    toggleDisabled: {
      onClick: async (item) => {
        updateSetting({
          variables: {
            input: {
              id: item.id,
              disabled: !item.disabled,
            },
          },
        });
      },
    },
    deleteButton: {
      render: (item) => (
        <DeleteButton
          type="link"
          danger={false}
          showIcon={false}
          content={`Do you want to delet ${item.title}?`}
          onOk={async () => {
            await deleteSetting({ variables: { id: item.id } });
          }}
        />
      ),
    },
  });

  return (
    <PageContainer
      loading={loading}
      header={{
        title: 'Funding Application Settings',
        extra: [
          <Button key="add" type="primary">
            <Link to="/system-setting/project-application-settings/add">
              <PlusOutlined /> Add
            </Link>
          </Button>,
        ],
      }}
    >
      <Card bordered={false}>
        <List
          itemLayout="horizontal"
          dataSource={sortData(data?.projectApplicationSettings)}
          renderItem={(item) =>
            item.deleted ? (
              ''
            ) : (
              <List.Item
                actions={listActions({ item })}
                style={{ flexWrap: 'wrap' }}
              >
                <List.Item.Meta
                  title={item.title}
                  description={
                    <>
                      <div>{item.code}</div>
                      <div>
                        {tagShowPriority(item.showPriority)}
                        <DateDisplay
                          date={item.startDate}
                          format="YYYY/MM/DD"
                        />{' '}
                        -
                        <DateDisplay date={item.endDate} format="YYYY/MM/DD" />
                      </div>
                    </>
                  }
                />
                {item.disabled ? (
                  <Tag>Disabled</Tag>
                ) : item.deleted ? (
                  <Tag color="red">Deleted</Tag>
                ) : (
                  <Tag color="green">Active</Tag>
                )}
              </List.Item>
            )
          }
          pagination={{
            pageSize: 20,
            hideOnSinglePage: true,
          }}
        ></List>
      </Card>
    </PageContainer>
  );
};
export default ProjectApplicationSettings;
